import { Update } from "@ngrx/entity";
import { createAction, props } from "@ngrx/store";
import { IPerson } from "src/app/interfaces";

export const addPerson = createAction(
  "[Person] Add Person",
  props<{ person: IPerson }>()
);

export const upsertPerson = createAction(
  "[Person] Upsert Person",
  props<{ person: IPerson }>()
);

export const addPersons = createAction(
  "[Person] Add Persons",
  props<{ persons: IPerson[] }>()
);

export const upsertPersons = createAction(
  "[Person] Upsert Persons",
  props<{ persons: IPerson[] }>()
);

export const updatePerson = createAction(
  "[Person] Update Person",
  props<{ person: Update<IPerson> }>()
);

export const updatePersons = createAction(
  "[Person] Update Persons",
  props<{ persons: Update<IPerson>[] }>()
);

export const deletePerson = createAction(
  "[Person] Delete Person",
  props<{ id: string }>()
);

export const deletePersons = createAction(
  "[Person] Delete Persons",
  props<{ ids: string[] }>()
);

export const clearPersons = createAction("[Person] Clear Persons");
